__turbopack_context__.v({
  "termsLink": "RewardsGetStartedTermsLink-module__zFw4iW__termsLink",
});
